import { Box, Skeleton } from '@mui/material'
import CardWithSpace from '../../components/Cards/CardWithSpace'

const EmployeeListContainerSkeleton = ({ size = 3 }) => (
  <>
    {[...Array(size)].map((item) => (
      <CardWithSpace
        key={item}
        customStyles={customStyle.cardWithSideColor}
      >
<Box>
          <Skeleton variant="text" sx={customStyle.title} />
          <Skeleton variant="text" sx={customStyle.subTitle} />
</Box>
<Box>
          <Skeleton variant="text" sx={customStyle.title} />
          <Skeleton variant="text" sx={customStyle.subTitle} />
</Box>
<Box>
          <Skeleton variant="text" sx={customStyle.title} />
          <Skeleton variant="text" sx={customStyle.subTitle} />
</Box>
<Box>
          <Skeleton variant="text" sx={customStyle.title} />
          <Skeleton variant="text" sx={customStyle.subTitle} />
</Box>
<Box>
          <Skeleton variant="text" sx={customStyle.title} />
          <Skeleton variant="text" sx={customStyle.subTitle} />
</Box>
      </CardWithSpace>
    ))}
  </>
)

const customStyle = {
  cardWithSideColor: {
    backgroundColor: 'transparent',
    p: {
      width: '100% ',
      xs: '5px 20px',
      sm: '16px 8px',
      md: '16px 20px',
      boxSizing: 'border-box',
      padding: {
        xs: '10px', sm: '16px', md: '16px 40px', lg: '16px 40px',
      },
    },
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: 'center',
    justifyContent: 'space-between',
    height: { xs: 'auto', md: '150px' },
  },
  title: {
    display: { xs: 'none', md: 'block' },
    width: '100px',
    height: '24px',
  },
  subTitle: {
    width: '150px',
    height: '24px',
  },
}

export default EmployeeListContainerSkeleton
